import { useContext, useCallback } from 'react';
import { RecaptchaContext } from './RecaptchaProvider';

/**
 * Custom hook to use reCAPTCHA v3
 * @returns {{ getToken: (action: string) => Promise<string|null>, isReady: boolean, error: Error|null }}
 */
const useRecaptcha = () => {
    const context = useContext(RecaptchaContext);

    const executeRecaptcha = context?.executeRecaptcha;
    const isReady = context?.isReady ?? false;
    const error = context?.error ?? null;

    const getToken = useCallback(async (action) => {
        if (!executeRecaptcha) {
            return null;
        }
        return executeRecaptcha(action);
    }, [executeRecaptcha]);

    if (!context) {
        console.warn('useRecaptcha must be used within a RecaptchaProvider. Returning no-op implementation.');
    }

    return {
        getToken,
        isReady,
        error
    };
};

export default useRecaptcha;
